import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const InstructionEditor = ({
  setInstruction,
  editorContentInstruction,
  editInformation,
  setEditInformation,
}) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    placeholder: "Start typing...",
    toolbarAdaptive: false,
    removeButtons: [
      "print",
      "font",
      "fontsize",
      "brush",
      "image",
      "file",
      "video",
      "about",
      "className",
      "paint",
      "lineHeight",
      "classSpan",
      "spellcheck",
      "copyformat",
      "ai-assistant",
      "ai-commands",
    ],
  };

  const handleEditorBlur = (newContent) => {
    // Trim whitespace and validate the content before splitting
    const trimmedContent = newContent.trim();
    if (!trimmedContent || trimmedContent === "<p><br></p>") {
      setEditInformation("This field is required.");
    } else {
      setEditInformation(""); // Clear error if content is valid
    }

    // Split content only if validation passes
    setInstruction(trimmedContent.split("<br/>"));
  };

  return (
    <div className="editor_our">
      <JoditEditor
        ref={editor}
        value={editorContentInstruction}
        config={config}
        tabIndex={1}
        onBlur={handleEditorBlur} // Validate on blur
      />
      {editInformation && <span style={{ color: "red" }}>{editInformation}</span>}
    </div>
  );
};

export default InstructionEditor;
